import React from 'react';
import { useNavigate } from 'react-router-dom';
import FinButton from '../../connect/finance/fin-button';
import { useFinanceSection } from '../section/finance-section-context';
import { describeFailure, NEXT_STEP } from './payout-failure-copy';

// The right panel of a payout that did not simply arrive (the owner's
// "Payout States" mock, frames 5d to 5f): why, and what to do about it.
// The statement help it replaces would send a restaurant looking for a
// deposit that never landed.
//
// The way to the bank is the same page the Dashboard's payouts-on-hold
// alert opens, and for the same people: the roles that may change the
// payout account (the finance section's `canManagePayouts`). Everyone else
// reads the reason and is told what to do, without a button they cannot use.
const HEADINGS = {
  failed: 'Why did this fail?',
  returned: 'Why was it returned?',
  canceled: 'What happens next?',
};

const PayoutIssueCard = ({ detail, state }) => {
  const d = detail || {};
  const navigate = useNavigate();
  const { canManagePayouts } = useFinanceSection() || {};
  const reason = state === 'canceled' ? null : describeFailure(d.failureCode, d.failureMessage);

  return (
    <aside
      data-testid="payout-issue"
      className="flex flex-col gap-3.5 border-t border-fin-border bg-fin-recess px-7 py-6 lg:border-l lg:border-t-0"
    >
      <h3 className="text-[14px] font-bold text-fin-ink">{HEADINGS[state]}</h3>
      {reason ? (
        <p className="text-[13px] leading-[1.55] text-fin-muted-2">
          <b className="font-bold text-fin-ink">{reason.title}</b>
          {` ${reason.detail}`}
        </p>
      ) : null}
      <p className="text-[13px] leading-[1.55] text-fin-muted-2">{NEXT_STEP[state]}</p>
      {state !== 'canceled' && canManagePayouts ? (
        <div>
          <FinButton
            variant="primary"
            size="sm"
            onClick={() => navigate('/dashboard/finance/business-details#payout-details')}
          >
            Update bank account
          </FinButton>
        </div>
      ) : null}
    </aside>
  );
};

export default PayoutIssueCard;
